import axios from "axios";
import JwtService from "@/core/services/jwt.service";
import store from "./store";
import { LOGOUT } from "@/core/services/store/auth.module";
/**
 * Service to call HTTP request via Axios
 */
var instance;
var url = "https://api.quebec-hd.aktin.net";
const ApiService = {
  serverURL: url,
  baseURL: `${url}/api/`,
  init() {
    instance = axios.create();
    instance.defaults.baseURL = this.baseURL;
    instance.interceptors.request.use(function(config) {
      var pharmacy = store.getters["currentPharmacy"];
      if (pharmacy) {
        config.headers.PharmacyGuid = pharmacy.guid;
      }
      config.headers.Authorization = `Bearer ${JwtService.getToken()}`;
      config.headers.ApplicationGuid = `08492cdb-dadf-4f96-8082-004d1acbe8f9`;
      config.headers["Accept-Language"] = "fr";
      return config;
    });

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const { status } = error.response;
        if (status === 401) {
          store.dispatch(LOGOUT);
        }
        return Promise.reject(error);
      }
    );
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    instance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return instance.get(resource, params).catch((error) => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource) {
    return instance.get(`${resource}`).catch((error) => {
      // console.log(error);
      throw new Error(`[KT] ApiService ${error}`);
    });
  },


  getBuffer(resource) {
    return instance
      .get(`${resource}`, {
        responseType: "arraybuffer",
      })
      .catch((error) => {
        // console.log(error);
        throw new Error(`[KT] ApiService ${error}`);
      });
  },


  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return instance.post(`${resource}`, params);
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return instance.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return instance.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return instance.delete(resource).catch((error) => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
};

export default ApiService;
